"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureType;
(function (FeatureType) {
    FeatureType["WRONG_ANSWERS"] = "WRONG_ANSWERS";
    FeatureType["SMART_LEARNING"] = "SMART_LEARNING";
    FeatureType["INVITE_PARENTS_EXAM_QUESTIONS"] = "INVITE_PARENTS_EXAM_QUESTIONS";
    FeatureType["INVITE_PARENTS_WRONG_ANSWERS"] = "INVITE_PARENTS_WRONG_ANSWERS";
    FeatureType["AI_QUIZ_GENERATION"] = "AI_QUIZ_GENERATION";
})(FeatureType = exports.FeatureType || (exports.FeatureType = {}));
